import "bootstrap";
import { gsap } from "gsap";
import { infiniteLogoSlider } from "./infinite-logo-slider";
import { verticalTabSlider } from "./vertical-tab-slider";
import { productSlider } from "./product-slider";

const inits = [
  { fn: infiniteLogoSlider, name: 'infiniteLogoSlider' },
  { fn: verticalTabSlider, name: 'verticalTabSlider' },
  { fn: productSlider, name: 'productSlider' },
];

inits.forEach(({ fn, name }) => {
  try {
    fn();
  } catch (error) {
    console.error(`Error initializing ${name}:`, error);
  }
});